import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Charge les traductions via HTTP (dans public/locales)
  .use(LanguageDetector) // Détecte la langue du navigateur
  .use(initReactI18next) // Passe l'instance i18n à react-i18next
  .init({
    supportedLngs: ['fr', 'en', 'ar'],
    fallbackLng: 'fr',
    lng: localStorage.getItem('i18nextLng') || 'fr', // Force 'fr' if no saved preference
    detection: {
      order: ['localStorage', 'navigator', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Chemin vers les fichiers de traduction
    },
    react: {
      useSuspense: false, // Évite les soucis de Suspense avec React 18+ si non géré
    },
  });

export default i18n;
